import { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { ScrollProgress } from "@/components/ui/ScrollProgress";
import { ScrollToTop } from "@/components/ui/ScrollToTop";
import { ContactFormSection } from "@/components/ui/ContactFormSection";
import { SEOTextBlock } from "@/components/ui/SEOTextBlock";
import { CookieConsent } from "@/components/ui/CookieConsent";

interface PageLayoutProps {
  children: ReactNode;
  contactFormTitle?: string;
  contactFormDescription?: string;
  hideContactMessage?: boolean;
  seoTitle?: string;
  seoContent?: string;
}

export function PageLayout({ 
  children, 
  contactFormTitle, 
  contactFormDescription, 
  hideContactMessage = true,
  seoTitle,
  seoContent
}: PageLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollProgress />
      <Header />
      <main className="flex-1">{children}</main>
      <ContactFormSection 
        title={contactFormTitle}
        description={contactFormDescription}
        hideMessage={hideContactMessage}
      />
      <Footer />
      {seoTitle && seoContent && (
        <SEOTextBlock title={seoTitle} content={seoContent} />
      )}
      <ScrollToTop />
      <CookieConsent />
    </div>
  );
}
